export class ProformasFilterComponentsValues {
    acceptedIsChecked: boolean;
    invoicedIsChecked: boolean;
    pendingIsChecked: boolean;
    rejectedIsChecked: boolean;
    dateFrom: string;
    dateTo: string;
    csiteId: number;
    operatorId: number;
    id: number;
}
